/**
 * Logger utility functions
 * 日志工具函数
 * 
 * In development mode, logs are output to console
 * In production mode, only errors are logged
 */

/**
 * Log general information (development only)
 * 记录一般信息（仅开发环境）
 */
export function log(...args) {
  if (import.meta.env.MODE === 'development' || import.meta.env.DEV) {
    console.log(...args)
  }
}

/**
 * Log errors (always logged)
 * 记录错误（总是记录）
 */
export function error(...args) {
  console.error(...args)
}

/**
 * Log warnings (development only)
 * 记录警告（仅开发环境）
 */
export function warn(...args) {
  if (import.meta.env.MODE === 'development' || import.meta.env.DEV) {
    console.warn(...args)
  }
}

/**
 * Log debug information (development only)
 * 记录调试信息（仅开发环境）
 */
export function debug(...args) {
  if (import.meta.env.MODE === 'development' || import.meta.env.DEV) {
    console.debug(...args)
  }
}

